import { Zap } from "lucide-react";
import { STATUS_FLOW } from "@/components/orders/statusConfig";

export function QuickStatusButton({ order, onAdvance }) {
  const idx = STATUS_FLOW.indexOf(order.status);
  if (idx < 0 || idx >= STATUS_FLOW.length - 1) return null;

  const isDelivery = !!order.delivery_address;
  const isPickup = order.source === "pickup" || (!order.delivery_address && !order.table_number);
  const isTable = !!order.table_number;

  // For pickup/table orders at "ready", skip "delivering" and go to "delivered"
  let next = STATUS_FLOW[idx + 1];
  if (order.status === "ready" && (isPickup || isTable)) {
    next = "delivered";
  }

  // For delivery at ready without deliverer - show label but don't auto-advance
  const needsDeliverer = order.status === "ready" && isDelivery && !order.deliverer_id;

  const labels = {
    preparing: "Produzir",
    ready: "Pronto",
    delivering: isPickup ? "Retirado" : isTable ? "Servido" : "Enviar",
    delivered: isPickup ? "Retirado" : isTable ? "Servido" : "Entregue",
  };
  const colors = {
    preparing: "bg-blue-500 hover:bg-blue-600",
    ready: "bg-emerald-500 hover:bg-emerald-600",
    delivering: "bg-purple-500 hover:bg-purple-600",
    delivered: "bg-gray-600 hover:bg-gray-700",
  };

  return (
    <button
      className={`${needsDeliverer ? "bg-purple-400 hover:bg-purple-500" : (colors[next] || "bg-gray-500")} text-white text-[10px] font-bold px-2 py-1 rounded-md transition-all flex items-center gap-1`}
      onClick={(e) => { e.stopPropagation(); if (!needsDeliverer) onAdvance(order.id, next); }}
      data-testid={`quick-advance-${order.id.slice(-6)}`}
    >
      <Zap className="w-3 h-3" />{needsDeliverer ? "Despachar" : labels[next]}
    </button>
  );
}
